import { Directive, ElementRef,  Input, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { BaseAttribute } from './baseAttribute';

@Directive({
    selector: '[alt-text]'
})
export class AltTextDirective extends BaseAttribute implements OnInit {

      constructor(private el: ElementRef,private translate: TranslateService ) { super(); }

      @Input('if')        generalIf: any;

      @Input('alt-param') altParam: any;

      @Input('alt-if')    altWhere: any;

      @Input ("alt-text") altText:string; 

      ngOnInit(): void {

            if ( this.altText ) {

                  this.altText  = super.ifCheck(this.altText, this.altWhere, this.generalIf );
                  this.altParam = super.paramCheck(this.altParam);

                  let input = this.el.nativeElement.querySelector('input');
                  if ( !input ) input = this.el.nativeElement.querySelector('select');

                  if ( input )
                       input.title = this.translate.instant(this.altText,this.altParam);
                  else 
                       this.el.nativeElement.title = this.translate.instant(this.altText,this.altParam);

                  this.translate.onLangChange.subscribe((event: Event) => {
                        if ( input )
                             input.title = this.translate.instant(this.altText,this.altParam);
                        else this.el.nativeElement.title = this.translate.instant(this.altText,this.altParam);
                  });
            }
      }      
}
